import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';

export enum GoalTreeItemIds {
  Goal = 'goal',
  LifeArea = 'life-area',
  NoLifeArea = 'no-life-area',
}

export type GoalTreeItemBase = {
  indentationLevel: number;
  displayColor?: string | null;
  parentName?: string;
  hasChildren?: boolean;
};

export type GoalItem = {
  type: GoalTreeItemIds.Goal;
} & GoalTreeItemBase &
  Goal;

export type LifeAreaItem = {
  type: GoalTreeItemIds.LifeArea;
} & GoalTreeItemBase &
  LifeArea;

export type NoLifeAreaItem = {
  type: GoalTreeItemIds.NoLifeArea;
  id: GoalTreeItemIds.NoLifeArea;
  name: string;
} & GoalTreeItemBase;

export type GoalTreeItem = GoalItem | LifeAreaItem | NoLifeAreaItem;
